import { render } from "./SprintCstfDeleteMark.vue?vue&type=template&id=167ac61e&scoped=true"
import script from "./SprintCstfDeleteMark.vue?vue&type=script&lang=js"
export * from "./SprintCstfDeleteMark.vue?vue&type=script&lang=js"

import "./SprintCstfDeleteMark.vue?vue&type=style&index=0&id=167ac61e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167ac61e"]])

export default __exports__